'use client'

import { storyblokEditable } from '@storyblok/react/rsc'
import Image from 'next/image'
import { type FC } from 'react'

import { Link } from 'base-ui'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokAdviceCardType } from '../../storyblok'
import { useStoryblokWebOrAppLink } from '../../useStoryblokLink'

export const StoryblokAdviceCard: FC<
  StoryblokComponentProps<StoryblokAdviceCardType>
> = ({ blok }) => {
  const { appLink, image, imageAlt, link, title } = blok

  const linkProps = useStoryblokWebOrAppLink({
    appLink,
    link,
  })

  if (!linkProps) {
    return null
  }

  return (
    <section
      className="relative flex flex-col gap-2"
      {...storyblokEditable(blok)}
    >
      {image ? (
        <Image
          alt={imageAlt}
          className="w-full rounded-s desktop:rounded-m"
          height={64}
          src={image}
          unoptimized
          width={148}
        />
      ) : null}
      {title ? (
        <h3 className="text-s font-medium">
          <Link {...linkProps} color="inherit" overlay>
            {title}
          </Link>
        </h3>
      ) : null}
    </section>
  )
}
